import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgLinkIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M43.862 14.125a3.2 3.2 0 0 0-4.526 0L26.925 26.537a3.2 3.2 0 0 0 0 4.525l4.605 4.606-2.262 2.263-4.606-4.606a6.4 6.4 0 0 1 0-9.051l12.412-12.412a6.4 6.4 0 0 1 9.05 0l6.012 6.012a6.4 6.4 0 0 1 0 9.05l-6.206 6.207-2.262-2.263 6.206-6.206a3.2 3.2 0 0 0 0-4.525zM34.73 26.068l4.606 4.606a6.4 6.4 0 0 1 0 9.05L26.925 52.138a6.4 6.4 0 0 1-9.051 0l-6.012-6.012a6.4 6.4 0 0 1 0-9.051l6.206-6.206 2.262 2.263-6.205 6.206a3.2 3.2 0 0 0 0 4.525l6.011 6.012a3.2 3.2 0 0 0 4.526 0l12.412-12.412a3.2 3.2 0 0 0 0-4.525l-4.606-4.606z"
    />
  </svg>
)
export default SvgLinkIcon
